module.exports = __webpack_public_path__ + "img/联系我们logo@2x.016b4973.png";